module.exports = __webpack_public_path__ + "static/media/cscs.a4ad7d66.jpg";